import React from 'react'
import ReactDOM from 'react-dom/client'

import { AppProviders } from './AppProviders'

import '../../i18n'
import './index.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
        <AppProviders />
    </React.StrictMode>
)
